module.exports = __webpack_public_path__ + "media/Instruction_A41.3fc9e57b.mp3";